export const dataIndex = {
  PASSENGERS: 0,
  SPEND: 1,
  TICKET_TYPES: 3,
  TOP_TEN_TRIPS: 2,
};
